export default __webpack_public_path__ + "static/media/o1-reflect.06b42449.png";